import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Button } from '@hackedu/react-components'
import queryString from 'query-string'
import changeInputHandler from 'app/views/utils/changeInputHandler'
import GenericModal from 'app/views/components/Modals/GenericModal'

import {
  registerUser,
  getConfirmedStatus,
  resendVerificationCode,
  logout,
} from 'app/views/utils/auth'

import settings from 'settings'
import validate from './validation'
import ButtonWithLoader from '../../components/ButtonWithLoader'

const propTypes = {}
const defaultProps = {}

class Register extends React.Component {
  constructor(props) {
    super(props)

    this.handleInputChange = changeInputHandler.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleResendVerificationEmail = this.handleResendVerificationEmail.bind(this)
    this.handleResendCode = this.handleResendCode.bind(this)
    this.state = {
      fields: {},
      errors: {},
      error: '',
      registered: false,
      success: {},
      showResendVerificationEmailLink: false,
      disableSubmitButton: false,
      showLinkToTroubleshootingVerificationIssues: false,
      user: null,
    }
  }

  componentDidMount() {
    if (this.props.isAuthenticated) {
      localStorage.setItem('hackedu.redirect.login.pathname', '/register')
      this.props.logout()
    }

    const queryStringValues = queryString.parse(this.props.location.search)
    if (queryStringValues.redirect_to) {
      localStorage.setItem("hackedu.redirect.onLogin", queryStringValues.redirect_to)
    }
    if (queryStringValues.email) {
      this.setState({fields: {email: queryStringValues.email}})
    }
  }

  handleResendVerificationEmail() {
    const {
      user,
    } = this.state
    this.setState({ isResendButtonLoading: true })
    user.resendConfirmationCode(() => {
      this.setState({
        showResendVerificationEmailLink: false,
        isResendButtonLoading: false,
        showLinkToTroubleshootingVerificationIssues: true,
      })
    })
  }

  async handleSubmit(_, callback = false) {
    const {
      fields,
    } = this.state
    const errors = validate(fields)
    if (Object.keys(errors).length) {
      return this.setState({
        errors,
      })
    }
    this.setState({ isButtonLoading: true })

    registerUser(fields)
      .then((user) => {
        this.setState({
          showResendVerificationEmailLink: true,
          disableSubmitButton: true,
          isButtonLoading: false,
          user,
          registered: true,
        })
      })
      .catch((err) => {
        getConfirmedStatus({ email: this.state.fields.email.toLowerCase() })
          .then(() => {
            this.setState({
              isButtonLoading: false,
              error: err.message,
            })
          })
          .catch((e) => {
            if (e.message === 'CONFIRMED') {
              this.setState({
                isButtonLoading: false,
                error: 'CONFIRMED',
              })
            } else {
              this.setState({
                isButtonLoading: false,
                error: 'NOT_CONFIRMED',
              })
            }
          })
      })
  }

  handleResendCode() {
    resendVerificationCode({ username: this.state.fields.email.toLowerCase() })
      .then(() => {
        const { errors } = this.state
        this.setState({
          success: {
            resendEmail: 'We have just resent the confirmation code to your email',
          },
          errors: {
            ...errors,
            resendEmail: null,
          },
        })
        this.resendModal.show()
      })
      .catch((err) => {
        const { errors, success } = this.state
        this.setState({
          errors: {
            ...errors,
            resendEmail: err.message,
          },
          success: {
            ...success,
            resendEmail: null,
          },
        }, () => {
          this.resendModal.show()
        })
      })
  }

  renderError() {
    switch (this.state.error) {
      case 'NOT_CONFIRMED':
        return (
          <span className="uk-text-danger">
            An account using that email address already exists, but has not been verified. <span
              className="_hover_error"
              onClick={this.handleResendCode}
              style={{
                fontTransform: 'underline',
                borderBottom: '1px solid #f0506e',
                cursor: 'pointer',
              }}
              type="button"
            >
              Resend Verification Email
            </span>
          </span>
        )
      case 'CONFIRMED':
        return (
          <span className="uk-text-danger">
            An account using that email address already exists
          </span>
        )
      case 'EMAIL_INVALID':
        return (
          <span className="uk-text-danger">
            The email is not valid as a company email. Please use an email that has your company domain.
          </span>
        )
      case '500':
        return (
          <span className="uk-text-danger">
            Something went wrong.
          </span>
        )
      default:
        return null
    }
  }

  render() {
    const {
      errors,
      error,
      showResendVerificationEmailLink,
      disableSubmitButton,
      isButtonLoading,
      isResendButtonLoading,
      showLinkToTroubleshootingVerificationIssues,
    } = this.state

    return (
      <div data-test-id="register-component" className="uk-background-muted" style={{ minHeight: 'calc(100vh - 10px)' }}>
        <div className="uk-container" style={{ maxWidth: 600 }}>
          <div className="uk-section uk-margin-large-bottom">
            <div className="uk-text-center">
              <Link className="uk-navbar-item uk-logo uk-navbar-toggle" to="/">
                <img src="/static/images/logo.png" style={{ maxWidth: 129 }} alt="Logo" />
              </Link>
              <h3>Create an account</h3>
            </div>
            <div className="uk-card uk-card-default uk-card-body uk-padding-large uk-margin-top" style={{ paddingBottom: 30 }}>
              {!this.state.registered ? (
                <form>
                  <div className="uk-margin">
                    <input
                      name="email"
                      value={this.state.fields.email}
                      type="text"
                      placeholder="Your company email"
                      className="uk-input"
                      onChange={this.handleInputChange}
                    />
                  </div>
                  <span className="uk-text-danger">{errors.email}</span>
                  <div className="uk-margin">
                    <input
                      name="password"
                      type="password"
                      placeholder="Password"
                      className="uk-input"
                      onChange={this.handleInputChange}
                    />
                  </div>

                  <div className="uk-margin">
                    <p className="uk-text-meta">
                      By registering, I agree to HackEDU's <a href={`${settings.urls.www}/privacy`} target="_blank" style={{ textDecoration: 'underline' }}>Privacy Policy</a> and <a href={`${settings.urls.www}/terms-of-service`} target="_blank" style={{ textDecoration: 'underline' }}>Terms of Service</a>.
                    </p>
                  </div>
                  <span className="uk-text-danger">{errors.password}</span>
                </form>
              )
                : (
                  <p className="uk-text-success uk-text-center uk-text-bold">We have sent you an email to verify your account</p>
                )}
              {error && this.renderError()}
              {!this.state.registered && (
                <div className="uk-margin">
                  <Button
                    isLoading={isButtonLoading}
                    onClick={this.handleSubmit}
                    disabled={disableSubmitButton}
                    primary
                    fullwidth
                    content="Register"
                  />
                </div>
              )}
              {
                showResendVerificationEmailLink && (
                  <ButtonWithLoader
                    className="uk-button uk-button-link uk-text-emphasis uk-align-center"
                    onClick={this.handleResendVerificationEmail}
                    isLoading={isResendButtonLoading}
                  >
                    Resend verification email
                  </ButtonWithLoader>
                )
              }
              {
                showLinkToTroubleshootingVerificationIssues && (
                  <a
                    href={`${settings.urls.www}/contact`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="uk-link-text"
                  >
                    Troubleshooting Verification Issues
                  </a>
                )
              }

            </div>
            <div className="uk-margin uk-text-center">
              <Link data-test-id="have-account-btn" to="/login">Already have account?</Link>
            </div>
          </div>
        </div>
        <GenericModal
          id="modal-resend-code-register"
          buttonType="uk-button-primary"
          ref={(ref) => { this.resendModal = ref }}
          title={this.state.errors.resendEmail ? 'Error' : 'Confirmation code resend'}
          body={(
            <>
              <p>{this.state.errors.resendEmail || this.state.success.resendEmail}</p>
            </>
          )}
          closeText="Ok"
        />
      </div>
    )
  }
}

Register.propTypes = propTypes
Register.defaultProps = defaultProps

const mapStateToProps = (state) => ({
  // auth
  isAuthenticated: state.auth.authenticationStatus === 'LOGGED_IN',
})

export default compose(connect(mapStateToProps, {
  logout,
}))(Register)
